import { BaseState } from '@/store/base-state';
import { TableOptions } from '@/types';
import { Staffs, StaffStatisticFilters } from '@/modules/staffs/types';

export default class AnalitycsListState extends BaseState {
  statistics: Staffs.StaffStatistic[] = [];
  statistics_loading = false;
  filters: StaffStatisticFilters = {};

  table_options: TableOptions = {
    ...this.create_table_opts,
    sortBy: ['course_name'],
    sortDesc: [true],
  };
}
